import { Dialog, DialogProps, useMediaQuery } from "@mui/material"

export const ResponsiveDialog = (props: DialogProps) => {
  const isFullScreen = useMediaQuery("(max-width:758px)")
  return <Dialog fullScreen={isFullScreen} fullWidth maxWidth="lg" {...props} />
}
